/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

/**
 * @const
 * @enum {string}
 */
const ImageScaling = Object.freeze({
  ACTUAL: 'Actual',
  CONTAIN: 'Contain'
})
export default ImageScaling
// RESERVE BELOW
export type ImageScalingStrings = typeof ImageScaling[keyof typeof ImageScaling]
